import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { registry } from '@cian/mf-registry/browser';
import { IApplicationContext } from '../../../shared/types/applicationContext';
import { ICustomContextParams } from '../../../shared/types/ICustomContextParams';
import { createMicrofrontendsAPI } from '../microfrontends/createMicrofrontendsAPI';

export const createContext = (): IApplicationContext => {
  const config = getConfig();

  const custom = config.getStrict<ICustomContextParams>('applicationContext.custom');

  return {
    custom,
    config,
    logger: getLogger(),
    httpApi: getHttpApi(),
    microfrontendsRegistry: registry(),
    microfrontendsAPI: createMicrofrontendsAPI(),
  };
};
